export default {
  Steps: {
    title: 'Steps',
    items: {
      Shipping: 'Shipping',
      Payment: 'Payment',
      Review: 'Review',
    },
  },
  Cart: {
    title: 'Cart',
    items: {
      'Button Back': 'Back To Catalog',
    },
  },
  Shipping: {
    title: 'Steps',
    items: {
      Title: 'Shipping',
      'Delivery Label': 'Delivery',
      Delivery: 'Delivery',
      'Self collect': 'Self collect',
      'Label Country': 'Country',
      'Label Email': 'Email',
      'Label First Name': 'First Name',
      'Label Last Name': 'Last Name',
      'Label Company Name': 'Company Name',
      'Label Company Number': 'Company Number',
      'Label Street Address': 'Street Address',
      'Label Address 2': 'Address 2',
      'Label City': 'City',
      'Label State': 'State, Province, or Region',
      'Label Zip Code': 'Zip Code',
      'Label Phone Number': 'Phone Number',

      'Label Shipping Method': 'Shipping Method',
      'Button Next': 'Next',
    },
  },
  Payment: {
    title: 'Payment',
    items: {
      Title: 'Payment',

      'Label Country': 'Country',
      'Label Email': 'Email',
      'Label First Name': 'First Name',
      'Label Last Name': 'Last Name',
      'Label Company Name': 'Company Name',
      'Label Company Number': 'Company Number',
      'Label Street Address': 'Street Address',
      'Label Address 2': 'Address 2',
      'Label City': 'City',
      'Label State': 'State, Province, or Region',
      'Label Zip Code': 'Zip Code',
      'Label Phone Number': 'Phone Number',
      'Label Payment method': 'Payment method',
      'Label Make billing address same as shipping': 'Make billing address same as shipping address',

      'Button Back': 'Back',
      'Button Next': 'Next',
    },
  },
  Review: {
    title: 'Review',
    items: {
      Title: 'Review Order',

      'Label Ship to': 'Ship to:',
      'Label Bill to': 'Bill to:',
      'Label Shipping Method': 'Shipping Method',

      'Button Back': 'Back',
      'Button Next': 'Pay',
    },
  },
  'Order Summary': {
    title: 'Order Summary',
    Checkout: 'Checkout',
    Pay: 'Pay',
    Next: 'Next',
    items: {
      Title: 'Order Summary',

      Subtotal: 'Subtotal',
      Shipping: 'Shipping',
      'Estimated Tax': 'Estimated Tax',
      'Coupon Discount': 'Coupon Discount',
      'Order Total': 'Order Total',

      'Review Order': 'Review Order',
      Checkout: 'Checkout',
      Promos: 'Promos',
      'Promos Apply': 'Apply',
      Pay: 'Pay',
      Next: 'Next',
    },
  },
  Errors: {
    title: 'Errors',
    items: {
      'Is mandatory': 'is mandatory',
    },
  },
  'Payment modal': {
    title: 'Payment modal',
    items: {
      Title: 'Payment',
      Button: 'Pay',
      'Card declined': 'Card declined',
      'Please wait while we process your payment': 'Please wait while we process your payment',
    },
  },
  ACH: {
    title: 'Stripe ACH',
    items: {
      'Pay Now': 'Pay Now',
      'Pay with Plaid': 'Pay with Plaid',
      'Credit Card': 'Credit Card',
      Plaid: 'Plaid',
      'ACH Bank Transfer': 'ACH Bank Transfer',
      Country: 'Country',
      'Routing number': 'Routing number',
      'Account number': 'Account number',
      'Holder name': 'Holder name',
      'Holder Type': 'Holder Type',
      'Microdeposit amount 1': 'Microdeposit amount 1',
      'Microdeposit amount 2': 'Microdeposit amount 2',
      'Verify Bank': 'Verify Bank',
    },
  },
}
